import $ from "jquery";
import videojs from "video.js";
import bdjs from "@bd-core/bdjs";
import fb from "@bd-core/firebase";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import GameLogic from "@bd-core/game-logic";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import {
    getCurrentRoomScreen,
    getFinalTeamAnswers,
    getIsRoomTimeOut,
    getPlayers,
    getRoomLogo,
    getRoomScore,
    getRoomStatus,
    getTotalAttempt,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    saveFinalRoomAnswers,
    setRadioOn,
    setRoomTotalScores,
    setTeamLogos,
    setTotalAttempt,
    getFinalRoomAnswers,
    updateCurrentScreen,
} from "@bd-core/firebase-actions";
import { isLeader } from "@bd-stores/game-progress";
import { isTestMode } from "@bd-utils/test-mode";

export class RoomRadioChatbot extends BD_Component {
    constructor() {
        super();

        this.id = "radio_chatbot";
        this.templateID = "radio_chatbot-template";

        this.elms = {
            // narrative popup
            narrativePopup: ".js-narrative-popup",
            narrativeCloseBtn: ".js-close-narrative-popup",

            // reward screen
            rewardScreen: ".js-reward-feedback",
            rewardTitle: ".js-reward-title",
            rewardSubtitle: ".js-reward-subtitle",
            rewardDescription: ".js-reward-description",
            rewardScore: ".js-reward-score",
            rewardContinueBtn: ".js-reward-continue-btn",
            triggerRewardScreenBtn: ".btn-continue-reward-screen",

            // customization
            customizationScreen: ".js-customization",
            customRewardWrapper: ".challange-prize__item-wrapper",
            customizationContinueBtn: ".js-customization-continue-btn",
            customizationCategory: ".js-category",
            logoImage: ".js-logo",

            // radio
            radioBox: ".js-radio-layout",
            radioFrequency: ".js-frequency",
            frequencyChannel: ".js-frequency-channel",
            powerBtn: ".js-power-btn",
            audio: "#audio",

            // puzzle / chatbot
            chatScreen: "#message-screen",
            readyInfo: "#notready",
            screenBox: "#screen-box",
            responseArea: ".js-response",
            loading: ".js-loading",
            inputCode: ".js-input-code",
            submitBtn: ".js-submit-btn",
            batteryItem: ".js-battery-item",
            checkBtn: ".js-check-btn",

            skipVideoBtn: ".js-skip-video"
        };

        this._events = this.getEvents();

        this.fbEvents = [];

        this._data = {};

        this.region = CONFIG.game.region;

        this.meSubmiting = false;

        this.audio = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.powerBtn,
                handler: this.onClickRadioButton,
            },
            {
                event: "click",
                selector: elms.radioFrequency,
                handler: this.adjustFrequency,
            },
            {
                event: "focus",
                selector: elms.inputCode,
                handler: this.handleInputState,
            },
            {
                event: "input",
                selector: elms.inputCode,
                handler: this.validateInput,
            },
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onSubmitCode,
            },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.updateRoomStatusToCompleted,
            },
            {
                event: "click",
                selector: elms.triggerRewardScreenBtn,
                handler: this.playOutroVideo,
            },
            {
                event: "click",
                selector: elms.rewardContinueBtn,
                handler: this.goToCustomizationScreen,
            },
            {
                event: "click",
                selector: elms.customizationContinueBtn,
                handler: this.setSelectedLogo,
            },
            {
                event: "click",
                selector: elms.narrativeCloseBtn,
                handler: this.closeNarrativePopup,
            },
            {
                event: "click",
                selector: elms.skipVideoBtn,
                handler: this.skipOutroVideo
            }
        ];
    }

    beforeInit() {
        this.render();
        this.setupSlider();
        this.setGameState();
        this.registerAudio();
        this.listenPlayersState();
        this.setTestMode();
    }

    getModifiedData() {
        const isTeamLeader = isLeader();
        const roomData = this._data;
        const modifiedData = {
            ...roomData,
            isLeader: isTeamLeader,
        };

        return modifiedData;
    }

    render() {
        const roomData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, roomData);
        $(".app").html(html);
    }

    setTestMode() {
        if (isTestMode()) {
            this.handleMachineCode();
            $(".app__back").removeClass("hidden");
        }
    }

    setGameState() {
        const self = this;
        const elms = this.elms;
        const roomId = this.roomId;
        const totalAttempts = getTotalAttempt(roomId);
        const roomAnswers = getFinalTeamAnswers(roomId);
        const roomStatus = getRoomStatus(roomId);
        const $responseBox = $(elms.responseArea);
        const $radioBox = $(elms.radioBox);
        const $powerBtn = $(elms.powerBtn);
        const $radioFrequency = $(elms.radioFrequency);

        if (roomStatus === "is-status-completed") {
            $radioBox.removeClass("on").addClass("off");
            $powerBtn.removeClass("on").addClass("off");
            $radioFrequency.attr("disabled");
        }

        /* force players to be on the same screen */
        const currentScreen = getCurrentRoomScreen(roomId);
        const video = videojs.getPlayer("outro-video-radio-chatbot");

        switch (currentScreen) {
            // case "search-find":
            //     $(".narrative-layer").show();
            //     $(".search-and-find-bg").show();
            //     break;
            case "video-outro":
                this.playOutroVideo();
                break;
            case "reward-screen":
                if ((video && video.ended()) || (video && video.paused())) {
                    this.goToRewardScreen();
                }
                break;
            case "customisations-screen":
                this.goToCustomizationScreen();
                break;
            case "puzzle-screen":
                $(".narrative-layer .screen .screen__inner").addClass("enter");
                setTimeout(() => {
                    $(".narrative-layer").css({
                        opacity: 0,
                        "pointer-events": "none",
                    });
                }, 500);
                this.handleBriefingPopup();
                $(".videobox").removeClass("is-open");
                $(elms.rewardScreen).removeClass("active");
                $(elms.customizationScreen).removeClass("active");
                break;
            default:
            //
        }
        /* END: force players to be on the same screen */

        /* handle battery items */
        for (let index = 1; index <= totalAttempts; index++) {
            const $theBattery = $(`${elms.batteryItem}[data-id=${index}]`);
            $theBattery.removeClass("filled");
        }

        const setChatScreen = function (answers) {
            let responses = "";
            let inc = 1;

            $.each(answers, function (index, item) {
                const { answer, status } = item;
                const questionObj = self.getQuestionText(answer, status);

                if (status === "machine") {
                    const { machine_code, machine_name } = questionObj;
                    const result = self.handleMachineCode(
                        machine_code,
                        machine_name,
                    );
                    responses += result;
                } else {
                    const result = self.handleQuestionCode(questionObj, inc);
                    responses += result;
                    inc++;
                }
            });

            $responseBox.html(responses);
        };

        if (!this.meSubmiting) setChatScreen(roomAnswers);

        const isRoomTimeout = getIsRoomTimeOut(roomId);
        if (isRoomTimeout && isLeader()) {
            $(self.elms.checkBtn).removeClass("hidden").prop("disabled", false);
        }
    }

    setupSlider() {
        $(".slick-slider").slick("refresh");
        const sliderSourcePopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".source-popup__nav-item.nav-pagination"),
            prevArrow: $(".source-popup__nav-item.nav-left"),
            nextArrow: $(".source-popup__nav-item.nav-right"),
        };

        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-source-wrapper").slick(sliderSourcePopup);
    }

    handleBriefingPopup() {
        let roomId = this.roomId;

        // fix https://www.pivotaltracker.com/story/show/186872215
        if (!isNaN(parseInt(roomId.toString()))) {
            roomId = parseInt(roomId.toString());
        }

        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        if (!states.briefing.includes(roomId)) {
            GameLogic.toggleBriefing();
        }
    }

    registerAudio() {
        const elms = this.elms;
        const $audio = $(elms.audio);

        if (!$audio.length) return;

        const url = $audio.attr("src");
        const audio = new Audio(url);
        this.audio = audio;
    }

    onClickRadioButton() {
        const elms = this.elms;
        const $powerBtn = $(elms.powerBtn);
        const userId = CONFIG.user.id;
        const roomId = this.roomId;
        $powerBtn.toggleClass("on off");

        setRadioOn(roomId, {
            [userId]: userId,
        });
    }

    scanPlayersListener(snapshot) {
        const elms = this.elms;
        const $audio = $(elms.audio);
        const $radioBox = $(elms.radioBox);
        const $radioFrequency = $(elms.radioFrequency);
        const $chatScreen = $(elms.chatScreen);
        const $ready = $(elms.readyInfo);
        const $powerBtn = $(elms.powerBtn);

        const roomId = this.roomId;
        const roomStatus = getRoomStatus(roomId);
        const value = snapshot.val();
        const playerStates = bdjs.indexedObjectToArray(value);
        const players = getPlayers();

        if (playerStates.length) {
            let allClicked = true;

            players.forEach((player) => {
                const isClicked = playerStates.find(
                    (id) => id == player.userId,
                );
                if (player.isOnline && !isClicked) allClicked = false;
            });

            if (allClicked) {
                $radioBox.removeClass("off tuning").addClass("on");
                $chatScreen.fadeIn();
                $ready.fadeOut();
                $powerBtn.addClass("on").removeClass("off");
                $powerBtn.prop("disabled", true);

                if (this.audio !== null) {
                    const self = this;

                    $audio.on("ended", function () {
                        self.audio.currentTime = 0;
                        self.audio.play();
                    });

                    if (roomStatus !== "is-status-completed") this.audio.play();
                }
            } else {
                $radioBox.removeClass("on").addClass("off tuning");
                $chatScreen.fadeOut();
                $ready.fadeIn();

                if (this.audio !== null) this.audio.pause();
            }

            $radioFrequency.prop("disabled", !allClicked);
        }
    }

    maybeAllPlayersReady() {
        const roomId = this.roomId;
        fb.get(`${fb.roomsPath}/${roomId}/players`).then((data) => {
            this.scanPlayersListener(data);
        });
    }

    listenPlayersState(off = false) {
        const roomId = this.roomId;
        const path = `${fb.roomsPath}/${roomId}/players`;
        const scanHandler = (data) => this.scanPlayersListener(data);
        const readyHandler = () => this.maybeAllPlayersReady();

        if (off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const readyListener = fb.onValue(path, scanHandler);
            const playerListener = fb.onValue(fb.playersPath, readyHandler);

            this.fbEvents.push(readyListener);
            this.fbEvents.push(playerListener);
        }
    }

    adjustFrequency(e, el) {
        const elms = this.elms;
        const $this = $(el);
        const $firstFreq = $(`${elms.radioFrequency}#freq-1`);
        const $secondFreq = $(`${elms.radioFrequency}#freq-2`);
        const $thirdFreq = $(`${elms.radioFrequency}#freq-3`);
        const firstFreqVal = Number($firstFreq.val());
        const secondFreqVal = Number($secondFreq.val());
        const thirdFreqVal = Number($thirdFreq.val());
        const firstValidFreq = Number($firstFreq.attr("data-valid"));
        const secondValidaFreq = Number($secondFreq.attr("data-valid"));
        const thirdValidFreq = Number($thirdFreq.attr("data-valid"));
        const firstReq = (firstValidFreq - firstFreqVal) / firstValidFreq;
        const secondFreq =
            (secondValidaFreq - secondFreqVal) / secondValidaFreq;
        const thirdFreq = (thirdValidFreq - thirdFreqVal) / thirdValidFreq;
        const totalFreq = firstReq + secondFreq + thirdFreq;
        const $indicatorLight = $(`#${$this.attr("data-freq")}-channel`);
        const $freqPulse = $(`#${$this.attr("data-freq")}`);
        const thisVal = Number($this.val());
        const thisValidVal = Number($this.attr("data-valid"));
        const correctVal = thisVal / thisValidVal;

        $indicatorLight.addClass("active");

        if (totalFreq == 0) {
            $indicatorLight.addClass("correct");
            $freqPulse.animate({
                opacity: 0,
            });
        } else if (correctVal == 1) {
            $indicatorLight.addClass("correct");
            $freqPulse.animate({
                opacity: 0,
            });
        } else if (correctVal != 1) {
            $indicatorLight.removeClass("correct");
            $freqPulse.animate({
                opacity: 1,
            });
        } else {
            $indicatorLight.removeClass("correct");
            $freqPulse.animate({
                opacity: 1,
            });
        }

        this.maybeAllFreqsCorrect();
    }

    maybeAllFreqsCorrect() {
        const elms = this.elms;
        const $freqChannel = $(elms.frequencyChannel);
        let isAllCorrect = true;

        $.each($freqChannel, function (index, item) {
            const isCorrect = $(item).hasClass("correct");

            if (!isCorrect) isAllCorrect = false;
        });

        if (isAllCorrect) {
            try {
                this.audio.pause();
            } catch (error) {
                console.error("Something wrong. Try Again.");
            }
        } else {
            try {
                this.audio.play();
            } catch (error) {
                console.error("Something wrong. Try Again.");
            }
        }
    }

    handleInputState(e, el) {
        const is_leader = isLeader();
        if (!is_leader) return;

        $(el).removeAttr("readonly");
    }

    validateInput(e) {
        e.preventDefault();

        const regex = new RegExp("^[0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);

        if (!regex.test(key)) {
            this.toggleSubmitButton();
            return false;
        }

        // this.toggleSubmitButton();
    }

    toggleSubmitButton() {
        const elms = this.elms;
        const $submitBtn = $(elms.submitBtn);
        const $inputCode = $(elms.inputCode);
        const hasAnswer = String($inputCode.val()).trim();

        $submitBtn.prop("disabled", !hasAnswer);
    }

    /**
     * Get questions and morrians answer text
     * @param {string} code
     * @returns {Object} questions text
     */
    getQuestionText(code, status) {
        const { questions, machine_codes } = this._data;
        let question;

        if (status === "machine") {
            question = machine_codes.find((item) => {
                return item.machine_code == code;
            });
        } else {
            question = questions.find((item) => {
                return item.answer_code == code;
            });
        }

        return question || {};
    }

    /* handle duplicate code */
    handleDuplicateCode() {
        let responses = "";
        const elms = this.elms;
        const $loading = $(elms.loading);
        const $responseBox = $(elms.responseArea);
        const $screenBox = $(elms.screenBox);
        const { display_messages } = this._data;

        $loading.removeClass("hidden");

        setTimeout(function () {
            $loading.addClass("hidden");

            responses += `<p class="warning"> ${display_messages.duplicate_question} <p><br/>`;

            $responseBox.append(responses);
            $screenBox.animate({ scrollTop: $screenBox.prop("scrollHeight") });
        }, 500);
    }

    /* handle incorrect / not found code */
    handleIncorrectCode() {
        let responses = "";
        const elms = this.elms;
        const $loading = $(elms.loading);
        const $inputCode = $(elms.inputCode);
        const $responseBox = $(elms.responseArea);
        const $screenBox = $(elms.screenBox);
        const { display_messages } = this._data;

        $loading.removeClass("hidden");

        setTimeout(function () {
            $loading.addClass("hidden");
            $inputCode.val("").trigger("focus");

            responses += `<p class="warning"> ${display_messages.incorrect_code} <p><br/>`;

            $responseBox.append(responses);
            $screenBox.animate({ scrollTop: $screenBox.prop("scrollHeight") });
        }, 500);
    }

    /* handle question / correct code */
    handleQuestionCode(questionObj, totalAttempt) {
        let responses = "";
        const elms = this.elms;
        const $loading = $(elms.loading);
        const $screenBox = $(elms.screenBox);
        const { display_messages } = this._data;

        const { warning_messages } = this._data;
        let notif = "";

        switch (totalAttempt) {
            case 1:
                notif = warning_messages.warning_first_question;
                break;
            case 2:
                notif = warning_messages.warning_second_question;
                break;
            case 3:
                notif = warning_messages.warning_third_question;
                break;
            default:
        }

        $loading.removeClass("hidden");
        $loading.addClass("hidden");
        $screenBox.animate({ scrollTop: $screenBox.prop("scrollHeight") });

        responses += `<p class="code"> ${display_messages.msg_code} ${questionObj.answer_code} ${display_messages.located} ${this.region} </p>`;
        responses += `<p class="question"> ${questionObj.question} </p>`;
        responses += `<p class="morrow"> ${display_messages.msg_located_morrow} </p>`;
        responses += `<p class="answer"> ${questionObj.morrians_answer} </p>`;
        responses += `<p class="warning"> ${display_messages.msg_warning} ${notif} </p> <br/>`;

        // $responseBox.append(responses);

        return responses;
    }

    /* handle machine code */
    handleMachineCode(machine_code, machine_name) {
        let responses = "";
        const elms = this.elms;
        const $loading = $(elms.loading);
        const $screenBox = $(elms.screenBox);
        const $checkBtn = $(elms.checkBtn);
        const $radioBox = $(elms.radioBox);
        const $powerBtn = $(elms.powerBtn);
        const { display_messages } = this._data;
        const is_leader = isLeader();

        $loading.removeClass("hidden");
        $loading.addClass("hidden");
        $screenBox.animate({ scrollTop: $screenBox.prop("scrollHeight") });

        responses += `<p class="code"> ${display_messages.msg_code} ${machine_code} // ${this.region} </p>`;
        responses += `<p class="question"> ${machine_name} </p><br/>`;

        if (is_leader) {
            $checkBtn.removeClass("hidden").prop("disabled", false);
        }

        $radioBox.addClass("off").removeClass("on");
        $powerBtn.addClass("off").removeClass("on");

        return responses;
    }

    /* submit code */
    onSubmitCode(e) {
        e.preventDefault();

        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        let totalAttempt = getTotalAttempt(roomId);
        let roomStatus = "is-status-started";
        const completedStatus = "is-status-completed";
        if (currentStatus === completedStatus) return;

        const is_leader = isLeader();
        if (!is_leader) return;

        this.meSubmiting = true;

        const elms = this.elms;
        const $submitBtn = $(elms.submitBtn);
        const $inputCode = $(elms.inputCode);
        const $responseBox = $(elms.responseArea);

        $submitBtn.prop("disabled", true);

        let askedCodes = getFinalTeamAnswers(roomId);
        if (askedCodes) {
            askedCodes = Object.values(askedCodes);
        } else {
            askedCodes = [];
        }

        const codeValue = String($inputCode.val()).trim();
        if (codeValue === "") return;

        // @ts-ignore
        const isDuplicate = askedCodes.find(
            (item) => codeValue === item.answer,
        );

        /* handle if input code is duplicate */
        if (isDuplicate) {
            this.handleDuplicateCode();
            return false;
        }

        const status = totalAttempt + 1 > 3 ? "machine" : "question";
        const questionObj = this.getQuestionText(codeValue, status);

        /* handle if the input code is not found */
        if (Object.keys(questionObj).length < 1) {
            this.handleIncorrectCode();
            return false;
        }

        totalAttempt++;
        setTotalAttempt(roomId, totalAttempt);

        const batteryItem = `battery_${totalAttempt}`;
        let statusCode = "question";

        /* handle machine code */
        if (totalAttempt == 4) {
            const { machine_code, machine_name, point_earned } = questionObj;
            setRoomTotalScores(roomId, Number(point_earned));
            // roomStatus = completedStatus;
            statusCode = "machine";

            const responses = this.handleMachineCode(
                machine_code,
                machine_name,
            );

            // @ts-ignore
            $responseBox.append(responses);
        } else {
            $submitBtn.prop("disabled", false);

            const responses = this.handleQuestionCode(
                questionObj,
                totalAttempt,
            );

            // @ts-ignore
            $responseBox.append(responses);
        }

        getFinalRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};

            let newAnswers = {
                ...fbRoomAnswers,
                [batteryItem]: {
                    answer: codeValue,
                    status: statusCode,
                },
            };

            // save temp answers
            saveFinalRoomAnswers(roomId, newAnswers);
        });

        const $batteryItem = $(`${elms.batteryItem}[data-id=${totalAttempt}]`);
        $batteryItem.removeClass("filled");

        $inputCode.val("").attr("readonly");
        maybeUpdateRoomStatus(roomId, roomStatus);
    }

    updateRoomStatusToCompleted() {
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const completedStatus = "is-status-completed";

        if (currentStatus === completedStatus) {
            this.playOutroVideo();
            return;
        }

        maybeUpdateRoomStatus(roomId, completedStatus);
    }

    skipOutroVideo() {
        const videos = videojs.getPlayers();
        const outroVideo = videos["outro-video-radio-chatbot"];
        
        outroVideo.dispose();
        this.afterPlayOutroVideo();
    }

    /* play outro video after submit code */
    playOutroVideo() {
        const $outroVideo = $(".videobox");
        const outroVideoUrl = this._data.video_block.video_outro;
        const is_leader = isLeader();

        if (is_leader) updateCurrentScreen(this.roomId, "video-outro");

        if (!$outroVideo.length) {
            this.goToRewardScreen();
            return false;
        }

        let states = Storage.get("states", {});
        let outroStates = states?.outroVideo || [];

        /**
         * check wheiter the video has url or not
         * if no url, close video popup and start room timer
         **/
        if (outroVideoUrl === "false") {
            this.goToRewardScreen();
            return false;
        }

        if (!outroStates.includes(this.roomId)) {
            // init video js with full screen
            const outroVideo = videojs("outro-video-radio-chatbot", {
                controls: true,
                autoplay: true,
                preload: "auto",
                sources: [
                    {
                        src: outroVideoUrl,
                        type: "video/mp4",
                    },
                ],
                techOrder: ["html5"],
            });

            // handle on ended video
            outroVideo.on("ended", () => {
                outroVideo.dispose();
                this.afterPlayOutroVideo();
            });

            // handle on error video
            outroVideo.on("error", function () {
                console.error("Can't play the video");
            });

            $outroVideo.addClass("is-open");

            try {
                outroVideo.play().catch((error) => {
                    // Autoplay was blocked. Do something
                    console.error("Unable to start auto play", error);
                    this.afterPlayOutroVideo();
                });
            } catch (error) {
                console.error(error);
                this.afterPlayOutroVideo();
            }
        } else {
            this.goToRewardScreen();
        }
    }

    /* handle after play video outro */
    afterPlayOutroVideo() {
        const $outroVideo = $(".videobox");
        let states = Storage.get("states", {});
        let outroStates = states?.outroVideo || [];

        if (!outroStates.includes(this.roomId)) {
            outroStates.push(this.roomId);
            states.outroVideo = outroStates;
            Storage.set("states", states);
        }

        $outroVideo.removeClass("is-open");
        this.goToRewardScreen();
    }

    /* show feedback reward screen */
    goToRewardScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const rewards = this._data.rewards || [];
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const teamname = CONFIG.game.teamname;
        const is_leader = isLeader();
        const $completionPopUp = $(".js-room-completion");
        const $outroVideo = $(".videobox");

        // @ts-ignore
        const reward = rewards.find((item) => roomScore == Number(item.points));

        let title, subtitle, description;

        if (reward?.title) {
            title = reward.title;
            title = title.replaceAll("{team_name}", teamname);
        }

        if (reward?.subtitle) subtitle = reward.subtitle;

        if (reward?.description) description = reward.description;

        $outroVideo.removeClass("is-open");
        $completionPopUp.removeClass("is-open");

        $rewardPopup.addClass("active");
        $rewardPopup.find(elms.rewardTitle).text(title);
        $rewardPopup.find(elms.rewardSubtitle).text(subtitle);
        $rewardPopup.find(elms.rewardDescription).html(description);
        $rewardPopup.find(elms.rewardScore).text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "reward-screen");

        // hide timer hint popup
        $(".js-popup-timerhint").removeClass("is-open");
    }

    /* show customization screen */
    goToCustomizationScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const $customizationPopup = $(elms.customizationScreen);
        const $score = $(elms.rewardScore);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);

        $(elms.customizationCategory).each(function () {
            const $slider = $(this).find(".challange-prize__item-wrapper");
            const isInitialized = $slider.hasClass("slick-initialized");
            const sliderCustomRewardOption = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                prevArrow: $(this).find(`.challange-prize__item-prev`),
                nextArrow: $(this).find(`.challange-prize__item-next`),
            };

            if (!isInitialized) $slider.slick(sliderCustomRewardOption);
        });

        $selectedCategory.addClass("is-selected");
        $rewardPopup.removeClass("active");
        $customizationPopup.addClass("active");
        $score.text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "customisations-screen");
    }

    setSelectedLogo() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomLogo = getRoomLogo(roomId);
        const roomScore = getRoomScore(roomId);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);
        const $activeSlide = $selectedCategory.find(".slick-active");
        const $theImg = $activeSlide.find(elms.logoImage);
        const selectedImg = $theImg.attr("data-image");

        // redirect player to mainroom
        const goToMainroom = () => {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            if (is_leader) updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        };

        if (roomLogo) goToMainroom();

        if (selectedImg == undefined) {
            goToMainroom();
            return false;
        }

        if (is_leader) {
            setTeamLogos(roomId, selectedImg)
                .then(goToMainroom)
                .catch(goToMainroom);
        } else {
            goToMainroom();
        }
    }

    closeNarrativePopup() {
        GameLogic.toggleNarrative();
    }

    beforeDestroy() {
        this.listenPlayersState(true);
    }
}
